
import { createContext } from "react";

export const GlobleContaxt = createContext();